// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UserDropdown_dropdown__L88GS","dropdown__item":"UserDropdown_dropdown__item__1YfUj","dropdownOverlay":"UserDropdown_dropdownOverlay__5FU44"};